import React from "react";
import { connect } from "react-redux";
import _ from "lodash"
import Select from "Components/common/Select/Select";
import Axios from "Source/axiosPool";
import SelectMultipleContainer from "Components/common/SelectMultipleContainer/SelectMultipleContainer";
import Tooltip from "@/src/components/common/Elements/Tooltip/Tooltip";
import moment from "moment";
import { withRouter } from "react-router";

@connect(store => {
    return {
        loggedUser: store.loggedUser,
    }
})

class Tasks extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            activeList:[],
            completedList:[],
            selected:{},
            pageActive:1,
            pageCompleted:1,
            name:null,
            isLoadingActive:false,
            isLoadingCompleted:false
        }

        _.map(
            ["fetchTaskList",
             "onRenderOption", 
             "handleClear",
             "bottomContent",
             "fetchActiveList",
             "fetchCompletedList",
             "handleLoadMore",
             "handleSearch"],
            fn => {
                this[fn] = this[fn].bind(this);
            }
        );
    }

    componentDidMount() {
        const {defaultSelected, timelog} = this.props
        //this.fetchTaskList()
          if(defaultSelected) {
              this.setState({selected:defaultSelected})
          }
          if(timelog.selected.account || timelog.selected.workstream) {
            this.fetchTaskList()
        }
    }
    
      componentDidUpdate(prev){
          const {timelog, defaultSelected, data} =this.props


        // Time keep page uses this as dropdown options too, so we avoid exiting the call if it is.
        // Best way to is to refactor/cleanup the global timelog component
        const isInTimekeepPage = this.props.history?.location?.pathname === '/my-timekeep';
        
          // Since there's no state to check for this because of jquery, we use the "in" class to check
          // only when the modal is open, should we fetch the tasks list and isInTimekeepPage
          if (!isInTimekeepPage && !document.querySelector('#logActivityTimeModal').classList.contains('in')) {
            return;
        }


          //for add
          if(!_.isEqual(prev.defaultSelected,defaultSelected ) && defaultSelected) {
            this.setState({selected:defaultSelected})
          } 
         
          if ((!_.isEqual(prev.timelog.selected.account, timelog.selected.account) && timelog.selected.account)
              || (!_.isEqual(prev.timelog.selected.workstream, timelog.selected.workstream) && timelog.selected.workstream)
              && !timelog.selected.task) {
              this.setState({ selected: {}, name:null }, () => {
                  this.fetchTaskList()
              })
          }
          if ((!_.isEqual(prev.timelog.selected.account, timelog.selected.account) && !timelog.selected.account)
          || (!_.isEqual(prev.timelog.selected.workstream, timelog.selected.workstream) && !timelog.selected.workstream)) {
            this.setState({ selected: {}, name:null }, () => {
              this.fetchTaskList()
          })
      }
      }
    
    async fetchTaskList() {
        
        const { loggedUser,timelog } = this.props
        const selected = timelog.selected
        const defaultParams={
            workstreamId: selected && selected.workstream,
            projectId: selected && selected.account,
        }
        this.setState({
            activeList:[],
            completedList:[],
        })
        if( selected && (selected.workstream || selected.account)){
            this.fetchActiveList(defaultParams)
            this.fetchCompletedList(defaultParams)
        } 

    }

    async fetchActiveList(defaultParams){
        const page = this.state.pageActive
        const url = 'api/task/getTaskListTimeLog';
        this.setState({isLoadingActive:true})
        await Axios.get(url, {
            ...defaultParams,
            type: "active",
            page:this.state.pageActive,
            name: this.state.name,
        }).then(res => {
            if (res && res.data) {
               const activeTasks = res.data.results.map(e=>{
                    return {
                            value: e.id,
                            label: e.task?e.task:"-",
                            date: moment.utc(e.adjustedDate).format('DD-MMM YYYY'),
                            section:'active',
                            total:res.data.count,
                            workstream:e.workstream
                    }
                });
                this.setState({activeList:page ===1?activeTasks:[...this.state.activeList,...activeTasks], isLoadingActive:false})
            } else {
                this.setState({isLoadingActive:false})
            }
        })
    }

    async fetchCompletedList(defaultParams){
        const url = 'api/task/getTaskListTimeLog';
        const page = this.state.pageCompleted
        this.setState({isLoadingCompleted:true})
        await Axios.get(url,{
            ...defaultParams,
            type: "completed",
            page:this.state.pageCompleted,
            name: this.state.name,
            ...!this.props.masterAdmin?{dateCompleted: moment().subtract('day',this.props.restrictionDays).startOf('day').format("YYYY-MM-DD")}:{}
        }).then(res => {
            if (res && res.data) {
               const completedTasks = res.data.results.map(e=>{
                    return {
                            value: e.id,
                            label: e.task?e.task:"-",
                            date: moment(e.dateCompleted).format('DD-MMM YYYY'),
                            section:'completed',
                            total:res.data.count,
                            workstream:e.workstream
                    }
                });    
                 
                this.setState({completedList:page ===1?completedTasks:[...this.state.completedList,...completedTasks],isLoadingCompleted:false})
            } else {
                this.setState({isLoadingCompleted:false})
            }
        })

    }

    handleLoadMore(type) {
        const { loggedUser, timelog } = this.props
        const selected = timelog.selected
        const defaultParams = {
            workstreamId: selected && selected.workstream,
            projectId: selected && selected.account,
        }

        if (type === 'active') {
            this.setState({ pageActive: this.state.pageActive + 1 }, () => {
                this.fetchActiveList(defaultParams)
            })
        } else {
            this.setState({ pageCompleted: this.state.pageCompleted + 1 }, () => {
                this.fetchCompletedList(defaultParams)
            })
        }
    }
    handleClear() {
        const{onChange}=this.props 
        if (onChange) {
            this.setState({selected:{}}, ()=>{
                onChange({ name: 'task', value: null })
            })     
        }
    }
    handleClose(){
        
    }
    onRenderOption( option ) {
        const isDelay = moment().startOf('d').isAfter(moment(option.date,"DD-MMM YYYY").startOf('d')) && option.section ==='active'
        return (
            <div class="account-item">
                <div class="account-name">
                    <span class={`${option.label.length > 50 ? "hasEllipsis" : ""}`}    data-tooltip-id={`menu_project_item_${option.value}`}>{ option.label.length > 50 ? `${option.label.substring(0, 50)}...` : option.label }</span>
                    { option.label.length > 50 && (
                        <Tooltip id={`menu_project_item_${option.value}`} place="bottom" effect="solid">
                            { option.label }
                        </Tooltip>
                    )}
                </div>   
                <div class="adjustedDate">
                    <span class={`${isDelay? 'delayed':''}`}> { option.date }</span>
                </div>
            </div>
        )
    }
    bottomContent(type) {
        return (<div >
            <p class="mb0 loadMoreContainer">
                <a onClick={() => this.handleLoadMore(type)}>Load More</a>
            </p>

        </div>)
    }
    handleSearch(value){
        const { loggedUser, timelog } = this.props
        const selected = timelog.selected
        const defaultParams = {
            workstreamId: selected && selected.workstream,
            projectId: selected && selected.account,
            
        }
        this.setState({ name: value, 
            pageActive:1,
            pageCompleted:1}, () => {
            this.fetchActiveList(defaultParams)
            this.fetchCompletedList(defaultParams)
            })
    }

    render() {
        const{onChange,defaultSelected,timelog,loggedUser,masterAdmin,defaultValue, optClasses='', restrictionDays=0}=this.props
        const{activeList,completedList,selected,isLoadingActive,isLoadingCompleted} = this.state
        const list = [...activeList,...completedList]
        const defaultOpt = defaultSelected
            ? list.filter(task=>task.value===defaultSelected.value)
            : [];
        const optionList = _.uniqBy([...defaultOpt,...list],'value')
        const onSelect = (e) => {  
            if (onChange) {
                this.setState({selected:e,name:null}, ()=>{
                    const taskSelected = (optionList.filter(f=>f.value === e.value)||[])[0]
                    onChange({ name: 'task', value: e.value, data:taskSelected})
                })   
            }
       }
       
        const otherProps = {
            hasRetriction: !masterAdmin,
            message:
                <p>Only tasks completed within 
                    <span style={{ "color": "#4A67DC" }}>
                        {` ${restrictionDays} day/s `}
                    </span> prior to current day will be available for selection.
                </p>
        }
        return (
            <div>
                {defaultValue ? <p class="defaultValue">{defaultValue}</p> :
                    <SelectMultipleContainer
                        isSearchable={true}
                        classes={{ options: `timelogSelectOptions taskTimelogSelect ${optClasses}` }}
                        placeholder="Select Task"
                        options={optionList}
                        hasScroll={true}
                        bottomContent={this.bottomContent}
                        renderOption={this.onRenderOption}
                        onChange={onSelect}
                        selected={selected}
                        onSearch={this.handleSearch}
                        // onOpen={this.fetchTaskList}
                        onClearSelected={this.handleClear}
                        loadingObj={{ isLoadingActive, isLoadingCompleted }}
                        disabled={!timelog.selected.account}
                        otherProps={otherProps}
                    //onOpen={this.fetchTaskList}
                    // options={list}
                    // onClearSelected={this.handleClear}
                    // selected={selected}
                    // onOpen={this.fetchTaskList}
                    // count={10}
                    // isFirstItemSelected={false}
                    // renderOption={this.onRenderOption}
                    />
                }
            </div>
        );
    }
}

export default withRouter(Tasks);
